// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InternalDocumentType } from '@interfaces/document.interfaces';

@Component({
    selector: 'app-internal-document-type',
    templateUrl: './internal-document-type.component.html',
    styleUrls: ['./internal-document-type.component.scss'],
})
export class InternalDocumentTypeComponent implements OnChanges {
    @Input() types: InternalDocumentType[];
    @Input() internalDocumentNotSelected;
    @Input() internalDocumentTypeSelected: InternalDocumentType;
    @Input() disabled?: boolean = false;
    @Output() public internalDocumentTypeChange = new EventEmitter();
    public selectedValue: InternalDocumentType = null;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.internalDocumentNotSelected?.currentValue) {
            this.internalDocumentNotSelected = changes?.internalDocumentNotSelected?.currentValue;
        }

        if (changes.internalDocumentTypeSelected?.currentValue) {
            if (changes.internalDocumentTypeSelected.currentValue.suggestedPreamble) {
                this.internalDocumentTypeSelected = changes.internalDocumentTypeSelected.currentValue;
            } else {
                this.internalDocumentTypeSelected = this.types.filter((t) => t.internalDocumentTypeId === changes.internalDocumentTypeSelected.currentValue)[0];
            }
        }
    }

    // used to set the value of the mat-select when populating the field since object is being passed in
    compareCategoryObjects(intDoc1: any, intDoc2: any) {
        return intDoc1 && intDoc2 && intDoc1.internalDocumentTypeId == intDoc2.internalDocumentTypeId;
    }

    updateDocument(event: any) {
        this.internalDocumentTypeChange.emit({
            context: 'selected-type',
            data: event.value,
        });
    }
}
